import { create } from 'zustand';
import { Author } from '@/lib/types';

interface ContentState {
  filters: any[];
  selectListFilters: { key: string; val: string }[];
  searchQuery: string;
  sortKey: string;
  page: number;
  initialized: boolean;
  selectedFilters: {
    [key: string]: string[];
  };
  stateVersion: number;
  authors: Author[];
  hasAuthor: boolean;
  setHasAuthor: (hasAuthor: boolean) => void;
  setFilters: (filters: any[]) => void;
  setSelectListFilters: (filters: { key: string; val: string }[]) => void;
  setSearchQuery: (query: string) => void;
  setSortKey: (key: string) => void;
  setPage: (page: number) => void;
  setInitialized: (initialized: boolean) => void;
  setSelectedFilters: (filters: { [key: string]: string[] }) => void;
  clearSelectedFilters: () => void;
  setAuthors: (authors: Author[]) => void;
  resetState: () => void;
}

const useContentState = create<ContentState>()((set, get) => ({
  filters: [],
  selectListFilters: [],
  searchQuery: '',
  sortKey: 'recent',
  page: 1,
  initialized: false,
  selectedFilters: {},
  stateVersion: 0,
  authors: [],
  hasAuthor: false,

  setFilters: (filters) =>
    set((state) => ({
      filters,
      stateVersion: state.stateVersion + 1,
    })),

  setSelectListFilters: (selectListFilters) =>
    set((state) => ({
      selectListFilters,
      stateVersion: state.stateVersion + 1,
    })),

  setSearchQuery: (searchQuery) =>
    set((state) => ({
      searchQuery,
      stateVersion: state.stateVersion + 1,
    })),

  setSortKey: (sortKey) =>
    set((state) => ({
      sortKey,
      stateVersion: state.stateVersion + 1,
    })),

  setPage: (page) =>
    set((state) => ({
      page,
      stateVersion: state.stateVersion + 1,
    })),

  setInitialized: (initialized) =>
    set((state) => ({
      initialized,
      stateVersion: state.stateVersion + 1,
    })),

  setSelectedFilters: (selectedFilters) =>
    set({
      selectedFilters: { ...selectedFilters },
      stateVersion: get().stateVersion + 1,
    }),

  clearSelectedFilters: () => {
    set({
      selectedFilters: {},
      stateVersion: get().stateVersion + 1,
    });
  },

  setAuthors: (authors) =>
    set((state) => ({
      authors,
      stateVersion: state.stateVersion + 1,
    })),

  setHasAuthor: (hasAuthor) =>
    set((state) => ({
      hasAuthor,
      stateVersion: state.stateVersion + 1,
    })),

  resetState: () => {
    set({
      selectListFilters: [],
      searchQuery: '',
      sortKey: 'recent',
      page: 1,
      initialized: false,
      selectedFilters: {},
      authors: [],
      hasAuthor: false,
      stateVersion: get().stateVersion + 1,
    });
  },
}));

export default useContentState;
